import React, { BaseSyntheticEvent, Ref, useCallback } from 'react';

import Textfield from '@atlaskit/textfield';
import { Field } from '@atlaskit/form';
import { formField } from './form-field.styles';
import { SpotlightTarget } from '.';

export const FormTextField = ({
  id,
  name,
  label,
  required,
  defaultValue,
  disabled,
  placeholder,
  forwardRef,
  onStepComplete,
  maxCharacterLength
}: FormTextFieldProps) => {
  const complete = useCallback(
    onStepComplete
      ? (data: BaseSyntheticEvent) => {
          if (validateData(data.target)) onStepComplete();
        }
      : () => console.warn('onStepComplete is not defined.'),
    [onStepComplete]
  );

  const keyDownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      event.key === 'Enter' &&
      validateData(event.target as CustomEventTarget)
    ) {
      event.preventDefault();
      if (onStepComplete) onStepComplete();
    }
  };

  const validateData = (target: CustomEventTarget) => {
    return target.value.length > 0;
  };

  return (
    <div css={formField}>
      <Field
        name={name}
        label={label}
        isDisabled={disabled}
        defaultValue={defaultValue}
        isRequired
      >
        {({ fieldProps }) => (
          <SpotlightTarget name={name}>
            <Textfield
              {...fieldProps}
              id={id}
              isRequired={required}
              placeholder={placeholder}
              onBlur={complete}
              onKeyDown={keyDownHandler}
              maxLength={maxCharacterLength}
              ref={forwardRef}
            />
          </SpotlightTarget>
        )}
      </Field>
    </div>
  );
};

type FormTextFieldProps = {
  id: string;
  name: string;
  label: string;
  required: boolean;
  defaultValue: string;
  placeholder?: string;
  disabled?: boolean;
  forwardRef?: Ref<HTMLInputElement>;
  onStepComplete?: () => void;
  maxCharacterLength?: number;
};

type CustomEventTarget = {
  value: string;
} & EventTarget;
